export const TAB_CONTACTO_TEL = 'contacto_tel';
export const TAB_CONTACTO = 'contacto';
export const TAB_OFICINAS = 'oficinas';
export const TAB_CRITERIOS = 'criterios';
export const TAB_FAQ = 'faq';

export const DEFAULT_ACTIVE_TAB = TAB_CONTACTO_TEL;